import React, { useState, useContext, useEffect } from "react";
import "../../forms-style.scss";
import { APP_NAVIGATION, ROUTE_CONSTANT } from "../../Util/Constants";
import ButtonComponent from "../../Components/Shared/ButtonComponent";
import { validateEmail, validatePassword } from "../../Validators/GenericValidator";
import InputType from "../../Components/Shared/InputType";
import UserServiceApi from "../../Services/UserService";
import {
  createCookie,
  DeleteTemplateDocId,
  getPortalCD,
  GetTemplateDocId,
  PerquisiteBountyEnable,
  readCookie,
  setIPConfig,
  redirectToPMSAndExistPlanPage,
} from "../../Util/helper";
import AuthServiceApi from "../../Services/AuthService";
import UserDataContext from "../../Contexts/User.context";
import { UserActionEnum } from "../../Config/UserType";
import { useNavigate } from "react-router-dom";
import PathHelper from "../../Util/PathHelper";
import DocBuilderService from "../../Services/DocBuilderService";
import ReactLoader from "../../Components/Shared/Loader/Loader";
import { appDomain, getFacebookClientId, getTenantId, getTenantGroupId } from "../../Util/general-config";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import { ERR_BAD_REQUEST } from "../../Config/Constants";
import FacebookLogin from "react-facebook-login";
import { useGoogleLogin, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { goToDashboardAfterDownload } from "../../Util/DownloadHelper";
import { v4 as UUID4 } from "uuid";
import EventService from "../../Services/EventService";

type Props = {};

const SignIn = (props: Props) => {
  const { state, dispatch } = useContext(UserDataContext);

  const navigate = useNavigate();
  const RedirectPath = PathHelper(APP_NAVIGATION.SINI);

  const [emailId, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [error, setError] = useState("");
  const [disableBtn, setdisableBtn] = useState(false);
  const [showLoader, setShowLoader] = useState("d-none");
  const { state: templateState } = useContext(TemplateDataContext);
  const { templatePath, selectedState, templates } = templateState;
  const onEmailChangeHandler = (e: { target: { value: any } }) => {
    const { value } = e.target;
    setEmail(value);
  };
  const onPwdChangeHandler = (e: { target: { value: any } }) => {
    setPasswordError(false);
    const { value } = e.target;
    setPwd(value);
  };
  const NavigateToPaymentMS = () => {
    let isNavigateToExistingPlanPage = redirectToPMSAndExistPlanPage();
    if (isNavigateToExistingPlanPage) {
      navigate(RedirectPath.next);
    }
  };
  const NavigateToHomeForAuth = () => {
    if (!!readCookie("jwtToken") || !!readCookie("refreshToken")) {
      goToDashboardAfterDownload(true);
      //navigate(ROUTE_CONSTANT.HOME);
    }
  };
  useEffect(() => {
    NavigateToHomeForAuth();
  }, []);
  const validateData = () => {
    if (emailId.trim() === "" && pwd.trim() === "") {
      setError("Email and Password are required");
    } else {
      setPasswordError(false);
      setEmailError(false);
      setError("");
      let errors = 0;
      const emailValidator = validateEmail(emailId.trim());
      if (emailValidator.isValid === false) {
        ++errors;
        setEmailError(true);
        setError("");
        setEmailErrorMsg(emailValidator.errorMessage);
      }
      const passwordValidator = validatePassword(pwd);
      if (passwordValidator.isValid === false) {
        ++errors;
        setPasswordError(true);
        setError("");
        if (pwd.trim() === "") {
          setPasswordErrorMsg("Password can't be blank");
        } else {
          setPasswordErrorMsg("Invalid Email or password.");
        }
      }
      if (errors > 0) {
        ++errors;
        setdisableBtn(false);
        return false;
      } else {
        setdisableBtn(true);
        return true;
      }
    }
  };

  const GoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      if (!!tokenResponse) {
        const userInfo = await axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`, {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          })
          .then((res) => {
            console.log(res);
            responseGoogle(res.data, tokenResponse.access_token);
          });
      } else {
        console.log("Failed to login with google 1");
        // setLoginError(true);
        // setLoginErrorMessage("Failed to login with google");
      }
    },

    onError: () => {
      console.log();
      console.log("Failed to login with google 2");
      // setLoginError(true);
      // setLoginErrorMessage("Failed to login with google");
    },
  });

  const responseGoogle = (response: any, accessToken: any) => {
    if (!!response && !!accessToken) {
      setShowLoader("d-block");
      setPasswordError(false);
      console.log(response);
      const { email, id } = response;
      const externalData = {
        createUser: {
          countryCD: setIPConfig("countryCode"),
          currencyCD: setIPConfig("currency"),
          portalCD: getPortalCD(),
          parentUserGuid: "",
          firstName: "",
          lastName: "",
          company: "",
          title: "",
          email: email,
          password: "",
          tenantId: getTenantId(),
          tenantGroupId: getTenantGroupId(),
        },
        externalLoginInfo: {
          loginType: 2,
          providerKey: id, // "100732998798818",
        },
      };
      UserServiceApi.createExternalUser(externalData).then((response: any) => {
        if (response) {
          const authData = {
            Username: email.trim(),
            UserGuid: response.userGuid,
            Email: email.trim(),
          };
          createCookie("userguid", response.userGuid, 1);
          AuthServiceApi.AuthenticateUser(authData).then((authResponse: any) => {
            const { jwtToken, refreshToken, expiresAt, legacyToken } = authResponse;
            localStorage.setItem("jwtToken", jwtToken);
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("expiresAt", expiresAt);
            createCookie("jwtToken", jwtToken, 1);
            createCookie("refreshToken", refreshToken, 1);
            createCookie("expiresAt", expiresAt, 1);
            createCookie("legacyTicket", legacyToken, 1);
            let data = {
              Id: UUID4(),
              UserId: response.userGuid,
              VisitorId: readCookie("visitorGuid"),
              VisitId: readCookie("visitGuid"),
            };
            EventService.EventPost(data, "user", "login", "user").then((response) => {});
            dispatch({
              type: UserActionEnum.SET_USERINFO,
              payload: { userGUID: response.userGuid, email: email.trim() },
            });

            let docid: string = "";
            let isPremiumUser = false;
            GetTemplateDocId(templatePath).then((value) => {
              if (value) {
                docid = value;
                DocBuilderService.updateUserGuid(docid, response.userGuid).then((updateResponse: any) => {
                  console.log("doc updated");
                  DeleteTemplateDocId(templatePath, false);

                  UserServiceApi.getUserProfile(response.userGuid).then((userProfileResponse: any) => {
                    if (userProfileResponse) {
                      console.log(userProfileResponse);
                      isPremiumUser = PerquisiteBountyEnable(
                        userProfileResponse.perquisiteBountyKey,
                        userProfileResponse.userGuid
                      );
                      if (isPremiumUser) {
                        if (docid) {
                          DocBuilderService.GeneratePDFPath(docid, response.userGuid).then((docResponse: any) => {
                            console.log(docResponse);
                            console.log("to dashboard..");
                            window.location.href = appDomain() + ROUTE_CONSTANT.USER_DASHBOARD;
                          });
                        }
                      } else {
                        console.log("to custm..");
                        navigate(RedirectPath.cstm);
                      }
                    } else {
                    }
                  });
                });
              } else {
                // NOTE ::: If local env then redirect on home page else on dashboard.
                if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
                  navigate(ROUTE_CONSTANT.HOME);
                } else {
                  console.log("to dashboard!!");
                  window.location.href = appDomain() + ROUTE_CONSTANT.USER_DASHBOARD;
                  setShowLoader("d-none");
                }
              }
            });
          });
        } else {
          //dispatch(savePersonalInfoFailure(response.data));
        }
      });
    } else {
      console.log("Invalid cred..");
    }
  };
  const responseFacebook = (response: any) => {
    //const typeofdoc = docType === DOC_TYPE.COVER_LETTER ? TYPE_OF_DOC.COVER_LETTER : TYPE_OF_DOC.RESUME;

    console.log(response);
    if (!!response && response.status != "unknown") {
      setShowLoader("d-block");
      setPasswordError(false);
      const { name, email, id } = response;
      const externalData = {
        createUser: {
          countryCD: setIPConfig("countryCode"),
          currencyCD: setIPConfig("currency"),
          portalCD: getPortalCD(),
          parentUserGuid: "",
          firstName: name,
          lastName: "",
          company: "",
          title: "",
          email: email,
          password: "",
          tenantId: getTenantId(),
          tenantGroupId: getTenantGroupId(),
        },
        externalLoginInfo: {
          loginType: 1,
          providerKey: id, // "100732998798818",
        },
      };
      UserServiceApi.createExternalUser(externalData).then((response: any) => {
        if (response) {
          const authData = {
            Username: email.trim(),
            UserGuid: response.userGuid,
            Email: email.trim(),
          };
          createCookie("userguid", response.userGuid, 1);
          AuthServiceApi.AuthenticateUser(authData).then((authResponse: any) => {
            const { jwtToken, refreshToken, expiresAt, legacyToken } = authResponse;
            localStorage.setItem("jwtToken", jwtToken);
            localStorage.setItem("refreshToken", refreshToken);
            localStorage.setItem("expiresAt", expiresAt);
            createCookie("jwtToken", jwtToken, 1);
            createCookie("refreshToken", refreshToken, 1);
            createCookie("expiresAt", expiresAt, 1);
            createCookie("legacyTicket", legacyToken, 1);
            let data = {
              Id: UUID4(),
              UserId: response.userGuid,
              VisitorId: readCookie("visitorGuid"),
              VisitId: readCookie("visitGuid"),
            };
            EventService.EventPost(data, "user", "login", "user").then((response) => {});

            dispatch({
              type: UserActionEnum.SET_USERINFO,
              payload: { userGUID: response.userGuid, email: email.trim() },
            });

            let docid: string = "";
            let isPremiumUser = false;
            GetTemplateDocId(templatePath).then((value) => {
              if (value) {
                docid = value;
                DocBuilderService.updateUserGuid(docid, response.userGuid).then((updateResponse: any) => {
                  console.log("doc updated");
                  DeleteTemplateDocId(templatePath, false);

                  UserServiceApi.getUserProfile(response.userGuid).then((userProfileResponse: any) => {
                    if (userProfileResponse) {
                      console.log(userProfileResponse);
                      isPremiumUser = PerquisiteBountyEnable(
                        userProfileResponse.perquisiteBountyKey,
                        userProfileResponse.userGuid
                      );
                      if (isPremiumUser) {
                        if (docid) {
                          DocBuilderService.GeneratePDFPath(docid, response.userGuid).then((docResponse: any) => {
                            console.log(docResponse);
                            console.log("to dashboard..");
                            window.location.href = appDomain() + ROUTE_CONSTANT.USER_DASHBOARD;
                          });
                        }
                      } else {
                        console.log("to custm..");
                        navigate(RedirectPath.cstm);
                      }
                    } else {
                    }
                  });
                });
              } else {
                // NOTE ::: If local env then redirect on home page else on dashboard.
                if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
                  navigate(ROUTE_CONSTANT.HOME);
                } else {
                  console.log("to dashboard!!");
                  window.location.href = appDomain() + ROUTE_CONSTANT.USER_DASHBOARD;
                  setShowLoader("d-none");
                }
              }
            });
          });
        } else {
          //dispatch(savePersonalInfoFailure(response.data));
        }
      });
    } else {
      console.log("login error..");
    }
  };
  const onSignIn = () => {
    const isValid = validateData();
    if (isValid) {
      setShowLoader("d-block");
      const params = {
        username: emailId.trim(),
        password: pwd.trim(),
        tenantGroupId: getTenantGroupId(),
      };
      const signinResponse = AuthServiceApi.LoginUser(params)
        .then((resp: any) => {
          const { jwtToken, refreshToken, expiresAt, ssoToken, legacyToken } = resp;
          localStorage.setItem("jwtToken", jwtToken);
          localStorage.setItem("refreshToken", refreshToken);
          localStorage.setItem("expiresAt", expiresAt);
          createCookie("jwtToken", jwtToken, 1);
          createCookie("refreshToken", refreshToken, 1);
          createCookie("expiresAt", expiresAt, 1);
          createCookie("ssoauth", "1");
          createCookie("ssoToken", ssoToken, 1);
          createCookie("legacyTicket", legacyToken, 1);
          setdisableBtn(false);
          return UserServiceApi.getUserByUserName(encodeURIComponent(params.username))
            .then((userResponse: any) => {
              if (userResponse) {
                const { userGuid, isMigrated } = userResponse;
                var validUserGuid = userGuid;
                if (userGuid.includes("-") == false) {
                  validUserGuid = userGuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
                }
                createCookie("userguid", validUserGuid, 1);
                let data = {
                  Id: UUID4(),
                  UserId: validUserGuid,
                  VisitorId: readCookie("visitorGuid"),
                  VisitId: readCookie("visitGuid"),
                };
                EventService.EventPost(data, "user", "login", "user").then((response) => {
                  //console.log("data posted", data, response);
                });

                dispatch({
                  type: UserActionEnum.SET_USERINFO,
                  payload: { userGUID: validUserGuid, email: userResponse.username },
                });
                let docid: string = "";
                let isPremiumUser = false;
                /**
                 * TO DO::
                 * Get docID w.r.t template
                 * Map Doc ID with user
                 * Get user profile is user is paid or not
                 * if user paid and doc in progress >> generate pdf and go to dashboard
                 * if user paid and no doc  >> go to dashboard
                 * if user not paid and doc in progress >> go to plan page
                 * if user not paid and no doc >> go to plan page
                 **/
                GetTemplateDocId(templatePath).then((value) => {
                  if (value) {
                    docid = value;
                    DocBuilderService.updateUserGuid(docid, validUserGuid).then((updateResponse: any) => {
                      console.log("doc updated");
                      DeleteTemplateDocId(templatePath, false);

                      UserServiceApi.getUserProfile(validUserGuid).then((userProfileResponse: any) => {
                        if (userProfileResponse) {
                          console.log(userProfileResponse);
                          isPremiumUser = PerquisiteBountyEnable(
                            userProfileResponse.perquisiteBountyKey,
                            userProfileResponse.userGuid
                          );
                          if (isPremiumUser) {
                            if (docid) {
                              DocBuilderService.GeneratePDFPath(docid, validUserGuid).then((docResponse: any) => {
                                console.log(docResponse);
                                // TO DO :: generate sso token before navigation
                                console.log("to dashboard..");
                                window.location.href = appDomain() + ROUTE_CONSTANT.USER_DASHBOARD;
                              });
                            }
                          } else {
                            console.log("to custm..");
                            window.location.href = appDomain() + ROUTE_CONSTANT.USER_DASHBOARD;
                          }
                        } else {
                        }
                      });
                    });
                  } else {
                    // NOTE ::: If local env then redirect on home page else on dashboard.
                    if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
                      navigate(ROUTE_CONSTANT.HOME);
                    } else {
                      console.log("to dashboard!!");
                      window.location.href = appDomain() + ROUTE_CONSTANT.USER_DASHBOARD;
                      setShowLoader("d-none");
                    }
                  }
                });
              }
            })
            .catch((err: any) => {
              setShowLoader("d-none");
            });
        })
        .catch((err: any) => {
          // TO DO :: Display Invalid User message.
          console.log("Invalid Crendetials");
          if (err.code == ERR_BAD_REQUEST) {
            setPasswordError(true);
            setPasswordErrorMsg("Invalid Email or password.");
          }
          setShowLoader("d-none");
          if (err.isAxiosError) {
            setdisableBtn(false);
          }
        });
    }
  };
  const onKeyDownHandler = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();

      onSignIn();
    }
  };
  return (
    <>
      <ReactLoader loaderProps={{ showloader: showLoader }} />
      <section className="signup_section">
        <div className="container">
          <div className="signup_inner">
            <h1>Member Login</h1>
            <div className="login-btn-group">
              <div id="newGoogleBtn" className="col-xs-12 margin-top-md ">
                <button onClick={() => GoogleLogin()} className="google-login-btn btn btn-signup">
                  <span className="signup-icon">
                    <img
                      src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                      alt="Google Logo"
                      className="google-logo"
                    />
                  </span>
                  <span className="font-weight-normal">Sign in With Google</span>
                </button>
              </div>
              <div id="newFbBtn" className="col-xs-12 margin-top-md">
                <div className="social-login--facebook">
                  <FacebookLogin
                    appId={getFacebookClientId()}
                    fields="name,email,picture"
                    textButton="Sign in With Facebook"
                    callback={responseFacebook}
                    icon={
                      <span className="signup-icon">
                        {" "}
                        <svg
                          version="1.2"
                          baseProfile="tiny"
                          id="Layer_1"
                          width="18px"
                          height="18px"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 33 33"
                        >
                          <g>
                            <path
                              fill="#1877F2"
                              d="M33,16.5C33,7.4,25.6,0,16.5,0S0,7.4,0,16.5c0,8.2,6,15.1,13.9,16.3V21.3H9.7v-4.8h4.2v-3.6
                                      c0-4.1,2.5-6.4,6.2-6.4c1.8,0,3.7,0.3,3.7,0.3v4.1h-2.1c-2,0-2.7,1.3-2.7,2.6v3.1h4.6l-0.7,4.8h-3.8v11.5C27,31.6,33,24.7,33,16.5z
                                      "
                            ></path>
                            <path
                              fill="#FFFFFF"
                              d="M22.9,21.3l0.7-4.8h-4.6v-3.1c0-1.3,0.6-2.6,2.7-2.6h2.1V6.8c0,0-1.9-0.3-3.7-0.3c-3.8,0-6.2,2.3-6.2,6.4
                                      v3.6H9.7v4.8h4.2v11.5c0.8,0.1,1.7,0.2,2.6,0.2c0.9,0,1.7-0.1,2.6-0.2V21.3H22.9z"
                            ></path>
                          </g>
                        </svg>
                      </span>
                    }
                  />
                </div>
              </div>
              <div id="innerPageExternalBtns" className="col-12">
                <div className="col-12 text-center">
                  Sign up with{" "}
                  <a
                    id="innergooglebutton"
                    title=""
                    href="javascript:__doPostBack('ctl00$unauthContentPlaceHolder$OpenAuthProviders$innergooglebutton','')"
                  >
                    Google
                  </a>
                  or
                  <a
                    id="innerfacebookbutton"
                    href="javascript:__doPostBack('ctl00$unauthContentPlaceHolder$OpenAuthProviders$innerfacebookbutton','')"
                  >
                    Facebook
                  </a>
                </div>
              </div>
            </div>
            {error && (
              <span key="pswrdErr">
                {" "}
                <span className="text-danger error-style">
                  {" "}
                  <small key="error">{error}</small>
                </span>
              </span>
            )}
            {(emailError || passwordError) && (
              <p key="pswrdErr" className="alert error signup-error-message error-style text-danger ">
                {/* <span>error prohibited this user from being saved:</span>
                    <br /> */}
                {emailError && (
                  <li>
                    <small key="pswrdErr">{emailErrorMsg}</small>
                  </li>
                )}

                {passwordError && (
                  <li>
                    <small key="pswrdErrw">{passwordErrorMsg}</small>
                  </li>
                )}
              </p>
            )}

            <div className="input_area">
              <p className="middle">
                <span></span> or <span></span>
              </p>
              <div className="form-group">
                <InputType
                  inputProps={{
                    id: "email",
                    text: "Email Address",
                    type: "email",
                    className: "form-control input-lg email",
                    index: 0,
                    name: "email",
                    placeholder: "Email",
                    value: emailId.trim() || "",
                    onKeyDown: { onKeyDownHandler },
                  }}
                  changeHandler={onEmailChangeHandler}
                />
              </div>
              <div className="form-group">
                <InputType
                  inputProps={{
                    id: "password",
                    text: "Password",
                    type: "password",
                    className: "form-control input-lg password",
                    index: 0,
                    name: "password",
                    placeholder: "Password",
                    value: pwd,
                    onKeyDown: { onKeyDownHandler },
                  }}
                  changeHandler={onPwdChangeHandler}
                />
              </div>
              <div className="check_box">
                {/* <label className="form-check">
                  {" "}
                  Remember me
                  <input className="form-check-input" type="checkbox" value="" />
                  <span className="checkmark"></span>
                </label> */}
                <label className="d-flex justify-content-center align-items-center">
                  <input type="checkbox" value="" />
                  <span className="w-100 h-auto px-1 d-block"> Remember me</span>
                </label>

                <a
                  href={ROUTE_CONSTANT.FORGET_PASSWORD}
                  id="unauthContentPlaceHolder_ForgotPasswordHyperLink"
                  className="setCulture"
                >
                  <b>Forgot ?</b>
                </a>
              </div>
              <div className="fbn bounce-effect">
                <ButtonComponent
                  buttonProps={{
                    disabled: disableBtn,
                    className: "theme_btn alante",
                    text: "Log in",
                    id: "logInBtn",
                  }}
                  clickHandler={onSignIn}
                />
              </div>
              <p>
                I don&apos;t have an Account-{" "}
                <a href={ROUTE_CONSTANT.SIGNUP} id="alreadyHaveAnAccountLinkNew" className="setCulture d-inline-block">
                  <i className="fa fa-user"></i> <b>Sign Up</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default SignIn;
